import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { media } from '@anm/styles/helpers';
import isFunction from 'lodash/fp/isFunction';
import { useMemo, FC, ReactNode } from 'react';
import styled from 'styled-components';

import { useWithCalculation } from './hooks';

type ListContainerProps = {
  itemWidth: number;
  className?: string;
  itemPadding?: number;
  children: ((width: number) => JSX.Element) | ReactNode;
};

const WrapperAdaptive = media.tablet`
  width: ${isMobileOrIPad() ? '100%' : 'auto'};
  margin: 0 20px;
`;

const Wrapper = styled.div`
  margin: 0 48px;
  max-width: 100%;
  width: fit-content;
  ${WrapperAdaptive};
`;

const SizeMeter = styled.div`
  height: 0;
  visibility: hidden;
`;

const ListContainer: FC<ListContainerProps> = ({ children, className, itemWidth, itemPadding = 0 }) => {
  const [newWidth, sizeMeterRef] = useWithCalculation({
    width: itemWidth,
    padding: itemPadding
  });

  const memorizedChildren = useMemo(() => {
    if (!newWidth) return null;

    return isFunction(children) ? children(newWidth) : children;
  }, [newWidth, children]);

  return (
    <>
      <SizeMeter ref={sizeMeterRef} />
      <Wrapper className={className}>{memorizedChildren}</Wrapper>
    </>
  );
};

export default ListContainer;
